// extracted by mini-css-extract-plugin
module.exports = {"cssMX1":".42","cssMY1":"0","cssMX2":".58","cssMY2":"1"};